import Vue from 'vue'
import axios from 'axios'
import store from '../store/index'
import router from '../router'

import {LoadingPlugin, ToastPlugin} from 'vux'

Vue.use(LoadingPlugin, ToastPlugin)

axios.interceptors.request.use(config => {
  // Vue.$vux.loading.show({
  //     text: '加载中'
  // })
  return config;
}, function (error) {
  return Promise.reject(error);
});

axios.interceptors.response.use(response => {
  // Vue.$vux.loading.hide()
  return response;
}, function (error) {
  // Vue.$vux.loading.hide()
  if (error.response.data.error === 'invalid_token') {
    store.dispatch('setUserInfo', {})
    sessionStorage.removeItem("userInfo")
    router.replace({name: 'center-login'})
  }
  return Promise.reject(error);
});

export default axios